<template>
  <div class="down-payment-list" :class="{ mobile: isMobile() }">
    <DownPaymentBox
      class="down-payment-box"
      :class="{ mobile: isMobile() }"
      @click="() => onClick(i)"
      v-for="(dpOption, i) in downPaymentOptions"
      :loadingValues="loadingValues"
      :key="i"
      :active="i === indexSelected"
      :downPaymentValue="dpOption.downPaymentValue"
      :downPaymentPercentage="dpOption.downPaymentPercentage"
      :economyValue="dpOption.economyValue"
      :version="version"
    />
  </div>
</template>

<script>
import StringMixin from '@/mixins/string';
import UtilMixin from '@/mixins/util';
import DownPaymentBox from '@/components/common/DownPaymentBox.vue';

export default {
  name: 'down-payment-list',
  mixins: [StringMixin, UtilMixin],
  components: { DownPaymentBox },
  methods: {
    downPaymentChange(index) {
      this.$emit('downPaymentChange', index);
    },
    onClick(index) {
      this.downPaymentChange(index);
    },
  },
  mounted() {
    if (typeof this.indexSelected === 'number' && this.indexSelected >= 0) {
      this.downPaymentChange(this.indexSelected);
    }
  },
  props: {
    indexSelected: {
      type: Number,
      default: 0,
    },
    downPaymentOptions: {
      type: Array,
      required: true,
    },
    loadingValues: {
      type: Boolean,
      default: false,
    },
    version: {
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
.down-payment-list {
  display: flex;
  justify-content: space-around;
  @media (min-width: 425px) {
    gap: 12px;
  }
  &.mobile {
    flex-direction: column;
  }
}

.down-payment-box.mobile {
  padding-top: 8px;
  flex: 1;

  &:first-child  {
    padding-top: 0;
  }
}
</style>
